import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-completed-payments-tab',
  templateUrl: './salvage-completed-payments-tab.component.html',
})
export class SalvageCompletedPaymentsTabComponent {
  @Input() context!: SalvageTabContext;
}
